/**
 * Parse JSON string
 *
 * @param {string} str JSON input string
 * @param {boolean} returnOriginal Return original data if error
 * @returns {object|string|null} JSON object
 */
export function parseIfValid(str, returnOriginal = true) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return returnOriginal ? str : null;
  }
}

